import { Component, OnInit, Input, OnChanges} from '@angular/core';
import { Router, ActivatedRoute, Params }   from '@angular/router';
declare var $: any;

import {EmbryoService } from '../../Services/Embryo.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'embryo-ShopDetails',
  templateUrl: './ShopDetails.component.html',
  styleUrls: ['./ShopDetails.component.scss']
})
export class ShopDetailsComponent implements OnInit, OnChanges {

   @Input() detailData : any;
   @Input() currency   : string;
   @Input() exchangeMX   : any;

   mainImgPath   : string;
   totalPrice    : any;
   old_price     : any;
   type          : any;
   colorsArray   : string[] = [];
   sizeArray     : number[] = [36,38,40,42,44,46,48];
   quantityArray : number[] = [];
   productReviews : any;

   constructor(private route: ActivatedRoute,
               private router: Router, 
               public embryoService : EmbryoService,
               public translate:TranslateService
               ) {
      this.embryoService.getProductReviews().valueChanges().subscribe(res => {this.productReviews = res});
   }

   ngOnInit() {
      this.mainImgPath = this.detailData.image;
      this.totalPrice  = this.detailData.discount_price; 
      this.old_price  = this.detailData.price;

      this.route.params.subscribe(res => {
         this.type = null;
         this.type = res.type; 
      });

      let length = +this.detailData.quantity;
      this.quantityArray = [length];
      this.detailData.quantity = 1; // after this step, We will use quantity as quantity of products to buy.
      for(var i =1;i<= length;i++)
      {
         this.quantityArray[i-1]=i;
      }
      
      if(this.detailData.colors !== undefined && this.detailData.colors !== null)
          this.colorsArray = this.detailData.colors.split(',');
   }

   ngOnChanges() {
      this.mainImgPath = null;
      this.totalPrice  = null;
      this.mainImgPath = this.detailData.image;
      this.totalPrice  = this.detailData.discount_price; 
      this.old_price   = this.detailData.price;
   }

   /**
    * getImagePath is used to change the image path on click event. 
    */
   public getImagePath(imgPath: string, index:number) {
      $('.p-link').removeClass('border-active');
      this.mainImgPath = imgPath;
      $("#"+index+"_img").addClass('border-active');
   }

   public calculatePrice(detailData:any, value: any) {
      detailData.quantity = value;
      this.totalPrice = detailData.discount_price*value;
   }

   public reviewPopup(detailData) {
      let reviews : any = null;
      for(let review of this.productReviews) {
         // if((review.id == detailData.id) && (review.type == detailData.type) && (review.category == detailData.category)){
         //    singleProduct = review;
         //    break;
         // }

        reviews = review.user_rating;
      }

      this.embryoService.reviewPopup(detailData, reviews);
   }

   public addToCart(value:any) {
      this.embryoService.addToCart(value);
   }

   public buyNow(value:any) {
      this.embryoService.buyNow(value);
      this.router.navigate(['/checkout']);
   }

}
